import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Row,
  Spin,
} from "antd";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import cnt from "../../../../../services/definedConstant";
import { BOM } from "../../../../../services/definedMethod";
import SuccessModal from "../../../component/SuccessModal";
import { apiConfig, labelConfig } from "../../../contractbooking.config";

const TerminateCallableBondContract = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  function onCancel() {
    navigate("/detail-bond-contract", { state: state });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.EditBondContract}/${state.id}/premature-redemption`;
    // const params = {
    //   command: "prematurelyredeem",
    // };
    formValues.redemptionDate = BOM.DateTime(
      formValues.redemptionDate,
      "only-date"
    );
    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        setIsModalVisible(true);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const handleGoBack = () => {
    navigate("/detail-bond-contract", {
      state: { ...state, statusValue: "approved" },
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={"Terminate Callable Deal"} pageItems={[]} />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Contract Ref ID: ${state.contractRefId}`}</Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={"Terminated on"}
                  name={"redemptionDate"}
                  style={{ flex: 1, marginBottom: 0 }}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.date),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={BOM.DisabledAfterCurrentDate}
                    style={{ width: "100%", height: "44px", marginBottom: 0 }}
                    className="bond-date-picker"
                  />
                </Form.Item>
              </Col>
              {/* <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item label={"Note"} name={"note"}>
                  <TextArea
                    placeholder={BOM.handlePlaceholderMsg("Note")}
                    autoSize={{
                      minRows: 1.5,
                      maxRows: 6,
                    }}
                    style={{
                      minHeight: "44px",
                      resize: "vertical",
                    }}
                  />
                </Form.Item>
              </Col> */}
            </Row>

            <Divider />
            <div
              style={{
                paddingTop: 20,
                borderRadius: 20,
              }}
            >
              <Flex justify="end" gap="10px" align="end">
                <Button
                  style={{
                    backgroundColor: "white",
                    borderRadius: 8,
                    border: "1px solid #D0D5DD",
                    padding: "20px 15px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                  colortext="#344054"
                  className="previous-button"
                  onClick={onCancel}
                >
                  Cancel
                </Button>
                <Button
                  style={{
                    backgroundColor: "#15CCAE",
                    color: "white",
                    border: "1px solid #BA24D5",
                    borderRadius: 8,
                    padding: "20px 15px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                  htmlType="submit"
                >
                  Submit
                </Button>
              </Flex>
            </div>
          </Form>
        </Card>
        <SuccessModal
          visible={isModalVisible}
          onClose={handleGoBack}
          successMessage={"Contract Terminated successfully"}
        />
      </Spin>
    </MainLayout>
  );
};
export default TerminateCallableBondContract;
